/*
 * @Author: Suroc
 * @Date: 2024-07-10 09:57:16
 * @LastEditTime: 2024-07-17 13:52:13
 * @Description: 
 */
import tool from './utils/tool.js'

export default {
  install(app) {
    //挂载全局对象
    app.config.globalProperties.$Tool = tool
    //注册全局组件
    // app.component('scTable', scTable)
  }
}
